import React, { useState } from 'react';
import {
  Typography,
  Box,
  FormControl,
  Select,
  MenuItem,
  Grid,
  Button,
  Paper,
} from '@mui/material';

// Labels legíveis para os dados
const labels = {
  efficiency: 'Eficiência',
  waterUsage: 'Uso de Água',
  soilHealth: 'Saúde do Solo',
  productivity: 'Produtividade',
  soilMoisture: 'Umidade do Solo',
  nitrogenLevels: 'Níveis de Nitrogênio',
  pH: 'pH',
  waterConsumption: 'Consumo de Água',
  fertilizerUsage: 'Uso de Fertilizantes',
  expectedYield: 'Produção Esperada',
  actualYield: 'Produção Real',
};

// Dados simulados para os relatórios
const simulatedData = {
  general: {
    title: 'Relatório Geral',
    description: 'Informações gerais sobre o desempenho e produtividade da plantação.',
    highlights: {
      efficiency: '85%',
      waterUsage: '72%',
      soilHealth: '88%',
      productivity: '92%',
    },
  },
  soil: {
    title: 'Relatório do Solo',
    description: 'Detalhes sobre umidade, nutrientes, pH e compactação.',
    highlights: {
      soilMoisture: '45%',
      nitrogenLevels: 'Adequado',
      pH: '6.5 (Neutro)',
    },
  },
  resources: {
    title: 'Relatório de Recursos',
    description: 'Consumo de água e uso de fertilizantes por área.',
    highlights: {
      waterConsumption: '12.3 litros/hectare',
      fertilizerUsage: '4.5 kg/hectare',
    },
  },
  productivity: {
    title: 'Relatório de Produtividade',
    description: 'Comparação entre produtividade esperada e real.',
    highlights: {
      expectedYield: '3.2 toneladas/hectare',
      actualYield: '3.0 toneladas/hectare',
    },
  },
};

const Reports = () => {
  const [selectedReport, setSelectedReport] = useState('general');

  const report = simulatedData[selectedReport];

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f9fafb', padding: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1f2937', mb: 2 }}>
        Relatórios
      </Typography>

      <Typography sx={{ mb: 2, color: '#374151' }}>
        Use os filtros abaixo para selecionar o relatório desejado:
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, mb: 4, flexWrap: 'wrap' }}>
        <FormControl sx={{ minWidth: 250 }}>
          <Select
            value={selectedReport}
            onChange={(e) => setSelectedReport(e.target.value)}
            displayEmpty
          >
            <MenuItem value="general">Relatório Geral</MenuItem>
            <MenuItem value="soil">Relatório do Solo</MenuItem>
            <MenuItem value="resources">Relatório de Recursos</MenuItem>
            <MenuItem value="productivity">Relatório de Produtividade</MenuItem>
          </Select>
        </FormControl>

        <Button variant="outlined" color="primary">
          EXPORTAR PDF
        </Button>
        <Button variant="outlined" color="primary">
          EXPORTAR EXCEL
        </Button>
      </Box>

      {/* Conteúdo do relatório selecionado */}
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1f2937', mb: 1 }}>
          {report.title}
        </Typography>
        <Typography sx={{ mb: 3, color: '#4b5563' }}>
          {report.description}
        </Typography>

        <Grid container spacing={2}>
          {Object.entries(report.highlights).map(([key, value]) => (
            <Grid item xs={12} sm={6} md={4} key={key}>
              <Paper sx={{ p: 2, textAlign: 'center', backgroundColor: '#f3f4f6' }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#374151' }}>
                  {labels[key]}
                </Typography>
                <Typography variant="h6" sx={{ color: '#1e40af' }}>
                  {value}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  );
};

export default Reports;
